import { DialogNodeTypes } from '../../../../architecture/enums/DialogComponentType';
import { DialogBlock } from '../../../DialogBlocks/DialogBlock';
import { SingleQuestionNode } from '../SingleQuestionNode';

export class EmailQuestionNode extends SingleQuestionNode {
  readonly type = DialogNodeTypes.EmailQuestionNode;
  constructor(block: DialogBlock) {
    super(block);

    this.title = 'Email Question Node';
  }
}
